module.exports = __webpack_public_path__ + "img/ring_memoires.832ccaf.webp";